import { IAuthorState } from "../../types/authorTypes";
import { GET_AUTHORS, GET_AUTHOR_DETAILS, RESET_AUTHOR_DETAILS, SET_AUTHOR_DETAIL_STATUS, SET_AUTHOR_LIST_STATUS } from "../constants/authorconstants";

const init: IAuthorState = {
  authors: {
    paginate: 25,
    total: 0,
    data: [],
    per_page: 25,
  },
  authorDetails: null,
  listStatus: false,
  detailStatus: false,
};

const authorReducer = (state: IAuthorState = init, action: any): IAuthorState => {
  switch (action.type) {
    case GET_AUTHORS: {
      return {
        ...state,
        authors: action.payload.data,
        listStatus: true,
      };
    }
    case SET_AUTHOR_LIST_STATUS: {
      return {
        ...state,
        listStatus: false,
      };
    }
    case SET_AUTHOR_DETAIL_STATUS: {
      return {
        ...state,
        detailStatus: false,
      };
    }
    case GET_AUTHOR_DETAILS: {
      return {
        ...state,
        authorDetails: action.payload.data,
        detailStatus: true,
      };
    }
    case RESET_AUTHOR_DETAILS: {
      return {
        ...state,
        authorDetails: null,
      };
    }

    default:
      return state;
  }
};
export default authorReducer;
